import React from "react";
import "../styles/Gallery.css";
import Navbar from "../components/NavBar";

import img1 from "../assets/Gallery/001.jpeg";
import img2 from "../assets/Gallery/002.jpeg";
import img3 from "../assets/Gallery/003.jpeg";
import img4 from "../assets/Gallery/004.jpeg";
import img5 from "../assets/Gallery/005.jpeg";
import img6 from "../assets/Gallery/006.jpeg";
import img7 from "../assets/Gallery/007.jpeg";
import img8 from "../assets/Gallery/008.jpeg";
import img9 from "../assets/Gallery/009.jpeg";
import img10 from "../assets/Gallery/010.jpeg";
import img11 from "../assets/Gallery/011.jpeg";
import img12 from "../assets/Gallery/012.jpeg";
import img13 from "../assets/Gallery/013.jpeg";
import img14 from "../assets/Gallery/014.jpeg";
import img15 from "../assets/Gallery/015.jpeg";
import img16 from "../assets/Gallery/016.jpeg";
import img17 from "../assets/Gallery/017.jpeg";

const images = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17
];

function Gallery() {
  return (
    
    <div className="gallery-page">
    <Navbar />
      <h1 className="gallery-title">Our Work</h1>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <div className="gallery-item" key={index}>
            <img src={img} alt={`gallery-${index}`} loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;